module.exports = __webpack_public_path__ + "img/ear-deaf.ccec03c4.svg";